"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocal = exports.isTest = void 0;
const isTest = (w = window) => (0, exports.isLocal)(w) ||
    w.location.hostname.includes("test-") ||
    w.location.hostname.includes(".pre.") ||
    w.location.hostname.includes("-dev.");
exports.isTest = isTest;
const isLocal = (w = window) => w.location.hostname === "localhost" ||
    w.location.hostname === "127.0.0.1" ||
    w.location.hostname.includes(".lh");
exports.isLocal = isLocal;
